import {
  BASE_URL,
  FEATURE_SETTINGS_ENDPOINT,
  SOMS_API_KEY,
  MAX_CAP_FEATURE,
  MAX_CAP_FORMAT_CSV,
} from "services/CONSTANTS";
import {
  DOWNLOAD_MAX_CAP_REPORT_FAILURE,
  DOWNLOAD_MAX_CAP_REPORT_REQUEST,
  DOWNLOAD_MAX_CAP_REPORT_RESET,
  DOWNLOAD_MAX_CAP_REPORT_SUCCESS,
} from "./action-type";
import { Get } from "services/apiService";

export const downloadMaxCapReportAction = () => {
  return (dispatch) => {
    dispatch(downloadMaxCapReportRequest());
    const apiUrl = `${BASE_URL}${FEATURE_SETTINGS_ENDPOINT}?feature=${MAX_CAP_FEATURE}&format=${MAX_CAP_FORMAT_CSV}&apikey=${SOMS_API_KEY}`;
    Get({ url: apiUrl })
      .then((response) => {
        if (response.status === 200) {
          dispatch(downloadMaxCapReportSuccess(response));
        } else {
          dispatch(downloadMaxCapReportFailure(response));
        }
      })
      .catch((err) => {
        dispatch(downloadMaxCapReportFailure(err));
      });
  };
};

const downloadMaxCapReportRequest = () => ({
  type: DOWNLOAD_MAX_CAP_REPORT_REQUEST,
});

const downloadMaxCapReportSuccess = (response) => ({
  type: DOWNLOAD_MAX_CAP_REPORT_SUCCESS,
  downloadMaxCapResponse: response,
});

const downloadMaxCapReportFailure = (error) => ({
  type: DOWNLOAD_MAX_CAP_REPORT_FAILURE,
  downloadMaxCapResponse: error,
});

export const downloadMaxCapReportReset = () => ({
  type: DOWNLOAD_MAX_CAP_REPORT_RESET,
});
